// Safari and React Native don't implement `requestIdleCallback`. When missing
// we run the callback synchronously rather than falling back to `setTimeout`,
// which has a higher priority than rIC and would defeat the perf purpose.
export const requestIdleCallbackSafe = (cb: () => void): number | undefined => {
  if (typeof requestIdleCallback === 'function') {
    return requestIdleCallback(cb);
  }
  cb();
  return undefined;
};

export const cancelIdleCallbackSafe = (handle: number | undefined): void => {
  if (handle !== undefined && typeof cancelIdleCallback === 'function') {
    cancelIdleCallback(handle);
  }
};
